"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyPressSequence = void 0;
const lodash_difference_1 = __importDefault(require("lodash.difference"));
const operators_1 = require("rxjs/operators");
function keyPresses(keyUp) {
    return observable => {
        return observable.pipe(operators_1.groupBy(e => e.keyCode), operators_1.mergeMap(group => {
            return group.pipe(operators_1.windowWhen(() => keyUp.pipe(operators_1.filter(e => e.keyCode === group.key))), operators_1.mergeMap(window => window.pipe(operators_1.distinctUntilChanged(), operators_1.first())));
        }));
    };
}
function multiKeyPresses(keyUp) {
    return observable => {
        return observable.pipe(keyPresses(keyUp), operators_1.pluck('keyCode'), operators_1.bufferWhen(() => keyUp), operators_1.filter(buffer => buffer.length > 0));
    };
}
function keyPressSequence(sequence, keydown, keyup) {
    return keydown.pipe(multiKeyPresses(keyup), operators_1.bufferCount(sequence.length), operators_1.filter(buffer => sequenceEquals(buffer, sequence)), operators_1.mapTo(true));
}
exports.keyPressSequence = keyPressSequence;
function sequenceEquals(sequence1, sequence2) {
    for (let i = 0; i < sequence1.length; i++) {
        const keySet1 = sequence1[i];
        const keySet2 = sequence2[i];
        if (keySet1.length !== keySet2.length) {
            return false;
        }
        if (lodash_difference_1.default(keySet1, keySet2).length > 0) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=keypresses.operator.js.map